// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.loader {
    width: 50px;
    aspect-ratio: 1;
    display: grid;
    -webkit-mask: conic-gradient(from 15deg, #0000, #000);
    animation: l26 1s infinite steps(12);
}

.loader,
.loader:before,
.loader:after {
    background:
        radial-gradient(closest-side at 50% 12.5%,
            #0082CB 96%, #0000) 50% 0/20% 80% repeat-y,
        radial-gradient(closest-side at 12.5% 50%,
            #0082CB 96%, #0000) 0 50%/80% 20% repeat-x;
}

.loader:before,
.loader:after {
    content: "";
    grid-area: 1/1;
    transform: rotate(30deg);
}

.loader:after {
    transform: rotate(60deg);
}

@keyframes l26 {
    100% {
        transform: rotate(1turn)
    }
}

.loader-message {
    margin-top: 20px;
    font-family: var(--font-inter-medium, sans-serif);
    font-size: 18px;
    color: #004E7A;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;;;IAGI;;;;sDAIkD;AACtD;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,iDAAiD;IACjD,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.9);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n}\n\n.loader {\n    width: 50px;\n    aspect-ratio: 1;\n    display: grid;\n    -webkit-mask: conic-gradient(from 15deg, #0000, #000);\n    animation: l26 1s infinite steps(12);\n}\n\n.loader,\n.loader:before,\n.loader:after {\n    background:\n        radial-gradient(closest-side at 50% 12.5%,\n            #0082CB 96%, #0000) 50% 0/20% 80% repeat-y,\n        radial-gradient(closest-side at 12.5% 50%,\n            #0082CB 96%, #0000) 0 50%/80% 20% repeat-x;\n}\n\n.loader:before,\n.loader:after {\n    content: \"\";\n    grid-area: 1/1;\n    transform: rotate(30deg);\n}\n\n.loader:after {\n    transform: rotate(60deg);\n}\n\n@keyframes l26 {\n    100% {\n        transform: rotate(1turn)\n    }\n}\n\n.loader-message {\n    margin-top: 20px;\n    font-family: var(--font-inter-medium, sans-serif);\n    font-size: 18px;\n    color: #004E7A;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
